const topMenuTabsReducer = (state = { tabs: [
  {
    id: 1, label: "Home", path: "/", states: {
      benchmarkeds: [],
      currentSurvey: {},
      currentSurveyResult: [],
      currentSurveyInsightData: {},
      homeSelectedTab: "",
      leftMenuContent: "",
      leftMenuVisibility: "show",
      leftMenuExpanded: true,
      leftMenuWidth: 418,
      newQuestion: {},
      newSurvey: false,
      organizations: [],
      questions: [],
      resultsCurrentQuestions: {},
      rightMenuWidth: 350,
      selectedSectionAndPage: {},
      surveyDetailSelectedTab: "Summary",
      surveyRecipients: [],
      surveys: [],
      themeMode: "dark",
      userSurveys: [],
      newSurveyNameFromLM: "",
      pageIsLoading: false
    }
  }
], activeTab: 1}, action) => {
  switch (action.type) {
    case "ADD_TAB":
      return { tabs: [...state.tabs, action.payload], activeTab: action.payload.id };
    case "REMOVE_TAB":
      if (state.activeTab === action.payload) {
        return { tabs: state.tabs.filter(tab => tab.id !== action.payload), activeTab: state.tabs[0].id };
      } else {
        return { tabs: state.tabs.filter(tab => tab.id !== action.payload), activeTab: state.activeTab };
      }
    case "SET_ACTIVE_TAB":
      return { tabs: state.tabs, activeTab: action.payload };
    case "UPDATE_TAB_PATH":
      return { tabs: state.tabs.map(tab => tab.id === action.payload.id ? { ...tab, label: action.payload.label, path: action.payload.path } : tab), activeTab: state.activeTab };
    case "UPDATE_TAB_STATES":
      return { tabs: state.tabs.map(tab => tab.id === action.payload.id ? { ...tab, states: { ...tab.states, [action.payload.key]: action.payload.value } } : tab), activeTab: state.activeTab };
    default:
      return state;
  }
}
export default topMenuTabsReducer;